import { connect } from "react-redux";

import AppOnboardingWrapper from "./AppOnboardingWrapper";
import {
  completeAppOnboardingStep,
  skipAppOnboardingStep,
  fetchAppOnboarding,
  showCompletionModal,
  hideCompletionModal,
  updateDiscountModalShown,
} from "./appOnboardingActions";

const mapStateToProps = state => ({
  appOnboardingState: state.appOnboarding,
});

const mapDispatchToProps = {
  fetchAppOnboarding,
  completeAppOnboardingStep,
  skipAppOnboardingStep,
  showCompletionModal,
  hideCompletionModal,
  updateDiscountModalShown,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppOnboardingWrapper);
